import { create } from 'zustand';

export interface CardBarConfig {
  visible: boolean;
  includeGeneral: boolean;
  compact: boolean;
  filterWatchOnly: boolean;
  filterFormulaCodes?: string[];
  disabledFormulaCodes?: string[];
  onSelectPath?: string; // e.g. '/hedges' → navigates to /hedges/:formulaId
}

const defaultConfig: CardBarConfig = {
  visible: true,
  includeGeneral: true,
  compact: true,
  filterWatchOnly: false,
};

interface CardBarStore {
  config: CardBarConfig;
  setConfig: (config: Partial<CardBarConfig>) => void;
  resetConfig: () => void;
}

export const useCardBarStore = create<CardBarStore>((set) => ({
  config: defaultConfig,
  setConfig: (partial) => set((state) => ({ config: { ...defaultConfig, ...partial } })),
  resetConfig: () => set({ config: { ...defaultConfig, visible: false } }),
}));
